import React from 'react';
import tickImage from '../assets/check.png'; // Replace with the actual path to your tick image

const ThankYouPage = () => {
    return (
    <div className="container">
  <div className="form-container">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <img src={tickImage} alt="Tick" style={{ width: '50px', height: '50px' }} />
        <h1 style={{ margin: '20px 0' }}>Thank You!</h1>
        <p>Your submission was successful.</p>
        <p>We will be in touch with you.</p>
      </div>
      </div>
      </div>
    );
  };

export default ThankYouPage;
